export default __webpack_public_path__ + "static/media/Crane-HPC.673ed573.png";